<ng-template #validateData>
	<app-validate-data
		[userData]="userData"
		[titleform]="titleValidateData"
		[securityQuestions]="securityQuestions"
		[documentId]="documentId"
		(cancelRequest)="cancelRequest($event)"
	>
	</app-validate-data>
</ng-template>
<div class="right_login olvide_mi_clave" *ngIf="showformValidate === false; else validateData">
	<form #myform="ngForm">
		<div class="content_form">
			<h1>Solicitud de contraseña</h1>
			<div class="tab-slider--container">
				<div class="usuario_contrasena center_content">
					<h1 class="igresa_tu_dni">Ingresa tu número de DNI o RUC</h1>
					<label class="codigo_de_socio">en caso no tuvieras ingresa tu código de socio</label>
					<app-alert *ngIf="messageError !== ''" title="Error" [message]="messageError" type="warn-ligth"> </app-alert>
					<div class="form_row clearfix dni_ruc_input">
						<div class="form_cell">
							<span class="user_dni_codigo">
								<input
									#numberDocument
									numeric
									type="text"
									[(ngModel)]="userCode"
									[ngClass]="{ val_error: validInputCode() }"
									name="numberIdentityDocument"
									[minlength]="3"
									[maxlength]="11"
									class="form_element"
									autocomplete="off"
									placeholder="Ingrese aqui su número"
									required
									[autofocus]="true"
									(blur)="fillSize()"
								/>
								<div *ngIf="validInputCode()" class="msj_validacion val_error">
									<i class="fa fa-times-circle-o"></i>
									<p>{{ messageErrorCode }}</p>
								</div>
							</span>
						</div>
					</div>
					<div class="center_content">
						<button class="boton_ingresar" [disabled]="disabledButton()" (click)="continueValidData()">
							CONTINUAR
						</button>
					</div>
				</div>

				<div class="revisar_correo">
					<div class="center_content no_recibi_correo">
						<a [routerLink]="['/login']" class="volver_enviar">Regresar al login</a>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
